import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const ChevronRight: BleskIcon = forwardRef(function ChevronRight(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        d="M10 16L14 12L10 8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
